import {Pipe, PipeTransform} from '@angular/core';
import Autolinker from 'autolinker';

@Pipe({
  name: 'linkify',
  standalone: true
})
export class LinkifyPipe implements PipeTransform {
  transform(text: string): string {
    if (text) {
      return Autolinker.link(text, {
        newWindow: true,
        className: 'linkify',
        truncate: {
          length: 30,
          location: 'smart'
        }
      });
    }
    return text;
  }
}
